import React from 'react';
import AutoSizeTitle from '../../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../../components/individualInformHeader/individualInformHeader';
import ResumeBarChartIndividual from '../../../graphics/resumeBarChartIndividual';
import IpraCard from '../../../components/selfcare360/ipraCard';
import IndividualRelTypeCount from '../../../components/individualRelTypeCount/individualRelTypeCount';
import { DimensionsLegendSelfcare360, IpraLegendSelfcare360 } from '../../../components/selfcare360/legendsSelfcare360';
import {
    SELFCARE360_DIMENSION_THRESHOLDS,
} from '../../../components/selfcare360/selfcare360Scales';
import { getIpraSummaryDisplayRows } from '../selfcare360InterventionPlan';
import '../../../components/selfcare360/resumeSelfcare360.css';

const PageResumeSelfcare360_1 = ({ selectedEvaluation, individualResult, pageNumber, orgLogo }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const summaryRows = getIpraSummaryDisplayRows(individualResult?.average_by_dimension);
    const dimensionsObj = summaryRows.reduce((acc, row) => {
        acc[row.code] = {
            title: row.summaryTitle,
            chartTitle: `${row.code} ${row.summaryTitle}`,
            average: row.score,
        };
        return acc;
    }, {});

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    <div className="selfcare360-resume-title">Resumen</div>

                    <div className="selfcare360-resume-hero">
                        <div className="selfcare360-resume-chart-panel">
                            <div className="selfcare360-resume-panel-title">Resultados por dimensión</div>
                            <ResumeBarChartIndividual
                                data={dimensionsObj}
                                redLight={SELFCARE360_DIMENSION_THRESHOLDS.redMax}
                                yellowLight={SELFCARE360_DIMENSION_THRESHOLDS.yellowMax}
                                serviceId={selectedEvaluation?.evl_srv_id}
                            />
                        </div>

                        <div className="selfcare360-resume-side-panel" style={{ marginTop: "40px" }}>
                            <div className="selfcare360-ipra-wrapper">
                                <IpraCard
                                    value={individualResult?.average} 
                                    marginOfError={individualResult?.margin_of_error || 0}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="selfcare360-legends-row">
                        <DimensionsLegendSelfcare360 />
                        <IpraLegendSelfcare360 />
                    </div>
                    <div className="selfcare360-validity-relcount">
                        <IndividualRelTypeCount relationshipsByType={individualResult?.relationships_by_type} />
                    </div>
                </div>


                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResumeSelfcare360_1;
